import { codeSplit } from 'bernie-core';

export const V3BreakerBioMap = codeSplit(() => import(/* webpackChunkName: "V3BreakerBioMap" */ '../components/v3-breaker-bio') as any);